import script from "./ClientCabinetAttachmentsTab.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientCabinetAttachmentsTab.vue?vue&type=script&setup=true&lang=js"

import "./ClientCabinetAttachmentsTab.vue?vue&type=style&index=0&id=dcd6e414&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dcd6e414"]])

export default __exports__